export default __webpack_public_path__ + "static/media/goshen101.787b2076.jpg";